import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'FETCH_ENRICHMENTS',
  'FETCH_SUCCESS',
  'FETCH_FAILED',

  'UPLOAD_FILE',
  'UPLOAD_FILE_SUCCESS',
  'UPLOAD_FILE_FAILED',

  'DELETE_FILE',
  'DELETE_FILE_SUCCESS',
  'DELETE_FILE_FAILED',

  'BEFORE_UPLOAD',
  'ON_REMOVE_FILE',
  'SET_FILE_NAME',
  'TABLE_CHANGE',
];

const { actions, actionTypes } = actionsPreprocessor('bulkEnrichment', actionNames);

export default actions;
export { actionTypes };
